export var tenantContext = 'x-tenant-context';
export var customerContext = 'x-customer-context';
export var authorizationTokenPrefix = 'Bearer ';
export var acceptLanguage = 'accept-language';
export var contentType = 'content-type';
export var jsonContentType = 'application/json';
export var authorization = 'authorization';
export var userAgent = 'user-agent';
export var acceptEncoding = 'Accept-Encoding';
export var clientApplication = 'x-client-application';
export var clientChannel = 'x-client-channel';
export var forwardedFor = 'x-forwarded-for';
export var useProductCaching = 'x-use-product-data-caching';
export var useProductsReadService = 'x-use-products-service';
export var loggedHeaders = [tenantContext, customerContext, clientApplication, acceptLanguage];
export var atpClusterId = 'x-atp-cluster-id';
export var customerTypeId = 'x-customer-type-id';
export var visitorSegment = 'x-visitor-segment';
export var xUseHcms = 'x-use-hcms';
export var xUsePascalCaseResponseFormat = 'x-use-pascal-case-response-format';
//# sourceMappingURL=headers.js.map